<template>
  <v-card>
    <v-card-title primary-title>
      <div>
        <div class="headline secondary--text">{{ $t('page.title') }}</div>
        <span class="body-1 greyDarken1--text">{{ $t('page.list.subtitle') }}</span>
      </div>
      <v-spacer></v-spacer>
      <v-btn color="secondary" dark class="mx-0" @click="$router.push({name: 'page.create'})">
        <v-icon small>$vuetify.icons.rms_create</v-icon>
        {{ $t('rms.button.create') }}
      </v-btn>
    </v-card-title>
    <!-- Default Pages -->
    <v-flex xs12 class="grey lighten-4 pa-3">
      <h3 class="secondary--text">
        {{ $t('page.list.def_pages') }}
        <v-tooltip top color="white">
          <template v-slot:activator="{on}">
            <v-icon size="19" v-on="on">mdi-information-outline</v-icon>
          </template>
          <span class="greyDarken3--text body-1">{{ $t('page.list.def_pages.tooltip') }}</span>
        </v-tooltip>
      </h3>
    </v-flex>
    <v-card-text>
      <v-layout row wrap>
        <v-flex xs12 sm12 md4>
          <v-checkbox
            v-model="local_def_pages.about"
            label="About"
            @change="updateCompany"
            :height="6"
            color="primary"
          />
        </v-flex>
        <v-flex xs12 sm12 md4>
          <v-checkbox
            v-model="local_def_pages.privacy"
            label="Privacy"
            @change="updateCompany"
            :height="6"
            color="primary"
          />
        </v-flex>
        <v-flex xs12 sm12 md4>
          <v-checkbox
            v-model="local_def_pages.terms"
            label="Terms"
            @change="updateCompany"
            :height="6"
            color="primary"
          />
        </v-flex>
      </v-layout>
    </v-card-text>
    <!-- Custom Pages -->
    <v-flex xs12 class="grey lighten-4 pa-3">
      <h3 class="secondary--text">{{ $t('page.list.custom_pages') }}</h3>
    </v-flex>
    <v-card flat>
      <v-card-text class="px-0">
        <v-data-table
          :headers="table_headers"
          :items="list"
          :loading="loading"
          v-bind:pagination.sync="pagination"
        >
          <template v-slot:items="props">
            <tr
              :style="{cursor: 'pointer'}"
              @click.stop="
                $router.push({
                  name: 'page.save',
                  params: {
                    page_id: props.item.id,
                  },
                })
              "
            >
              <td class="text-xs-left subheading">{{ props.item.title[currentLocale] }}</td>
              <td class="text-xs-left">{{ props.item.slug }}</td>
              <td class="text-xs-left">
                <v-chip class="secondary secondary--text font-weight-medium" small outline>
                  {{ DEFINES.SCREENER_STATUS[props.item.published] }}
                </v-chip>
              </td>
              <td
                class="text-xs-left"
              >{{ moment.utc(props.item.created_at).local().format('MMMM Do YYYY') }}</td>
              <td class="text-xs-center">
                <v-tooltip slot="append" top color="white">
                  <v-btn
                    slot="activator"
                    icon
                    small
                    dark
                    @click.stop="
                      $router.push({
                        name: 'page.save',
                        params: {
                          page_id: props.item.id,
                        },
                      })
                    "
                  >
                    <v-icon color="secondary">$vuetify.icons.rms_visibility</v-icon>
                  </v-btn>
                  <span class="greyDarken3--text body-1">
                    {{
                    $t('rms.tooltip.view')
                    }}
                  </span>
                </v-tooltip>

                <v-tooltip slot="append" top color="white">
                  <v-btn
                    slot="activator"
                    icon
                    small
                    dark
                    @click.stop="deleteConfirmation(props.item.id)"
                  >
                    <v-icon color="secondary">$vuetify.icons.rms_delete</v-icon>
                  </v-btn>
                  <span class="greyDarken3--text body-1">
                    {{
                    $t('rms.tooltip.delete')
                    }}
                  </span>
                </v-tooltip>

                <v-tooltip slot="append" top color="white">
                  <v-btn 
                    slot="activator"
                      icon
                      small
                      dark
                    @click.stop="copyPageLink(props.item)"
                  >
                    <v-icon color="secondary" left>$vuetify.icons.rms_copy</v-icon>
                  </v-btn>
                  <span class="greyDarken3--text body-1">
                    {{ $t('rms.tooltip.copy_link') }}
                  </span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
        <ConfirmationDialog
          :dialog="confirmation"
          @confirm="remove()"
          @cancel="confirmation = false"
        />
      </v-card-text>
    </v-card>
  </v-card>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import ConfirmationDialog from "@/components/dialogBox/Confirmation";
import i18n from "@/i18n";
import { utcToTz } from "@/helper";

export default {
  name: "PageList",
  data() {
    return {
      search: "",
      total: 0,
      confirmation: false,
      loading: true,
      table_headers: [
        {
          text: i18n.t("page.list.table.header.title"),
          align: "left",
          sortable: true,
          value: "id"
        },
        {
          text: i18n.t("page.list.table.header.slug"),
          align: "left",
          sortable: false,
          value: "title"
        },
        {
          text: i18n.t("page.list.table.header.status"),
          align: "left",
          sortable: false,
          value: "published"
        },
        {
          text: i18n.t("page.list.table.header.created_on"),
          align: "left",
          sortable: true,
          value: "created_at"
        },
        {
          text: i18n.t("page.list.table.header.action"),
          align: "center",
          sortable: false,
          value: "action"
        }
      ],
      pagination: { sortBy: "title", descending: true, rowsPerPage: 5 },
      local_def_pages: {
        about: true,
        privacy: true,
        terms: true
      },
      deletePageId: null
    };
  },
  created() {
    this.setDefaultPages();
    this.getApiData();
  },
  computed: {
    ...mapState({
      list: state => state.page.list,
      company: state => state.company.company
    }),
    currentLocale() {
      return this.$i18n.locale;
    },
  },
  components: { ConfirmationDialog },
  methods: {
    setDefaultPages() {
      if (
        this.company.custom_properties &&
        this.company.custom_properties.hasOwnProperty("def_pages")
      ) {
        this.local_def_pages = this.company.custom_properties.def_pages;
      }
    },
    async getApiData() {
      this.loading = true;
      try {
        var response = await this.$store.dispatch("page/list");
        this.total = response.pages.total;
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR
        });
      }
      this.loading = false;
    },

    async remove() {
      try {
        await this.$store.dispatch("page/delete", {
          id: this.deletePageId
        });
        this.getApiData();
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR
        });
      } finally {
        this.confirmation = false;
      }
    },

    async updateCompany() {
      this.company.custom_properties["def_pages"] = this.local_def_pages;
      try {
        var response = await this.$store.dispatch(
          "company/update",
          this.company
        );
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error"
        });
      }
    },

    deleteConfirmation(page_id) {
      this.deletePageId = page_id;
      this.confirmation = true;
    },
    copyPageLink(page) {
      const pageLink = `${this.company.domain}/${page.slug}`;
      navigator.clipboard.writeText(pageLink).then(() => {
        this.$store.dispatch("app/showMessage", {
          message: this.$t("rms.message.copy_link_alert"),
          color: "success"
        });
      }).catch(err => {
        console.error('Failed to copy: ', err);
      });
    }
  }
};
</script>
